<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style lang="less">
#app {
  min-width: 1400px;
  font-family: "MicrosoftYaHei";
  a {
    text-decoration: none;
  }

  img{
    border-radius: 3px;
  }

  h3 {
    margin: 0px 0 !important;
  }
  h4 {
    margin: 0 0 !important;
  }
}
</style>
